
class TimeInput {
    [x: string]: any;

    $onInit() {
        this.minute = Math.floor(this.value / 60);
        this.second = this.value % 60;
    }

    toSeconds() {
        this.value = ((this.minute || 0) * 60) + (this.second || 0);
        if (!this.value) this.value = null;
    }
}

export default {
    controller: TimeInput,
    template : require('./time.input.html'),
    bindings: {value: "="}
};
